module.exports = __webpack_public_path__ + "img/close.8c9b4fce.svg";